<template>
  <div class="customers-register" />
</template>

<script>

/**
 * Vue: Customers register (customers-register)
 * -----------------------------------------------------------------------------
 * Register page section.
 * - Limited interactivity section.
 *
 */
export default {
  name: 'CustomersRegister',

  mounted() {
    this.handleFormSubmit()
  },

  methods: {

    /**
     * Handle form submit.
     */
    handleFormSubmit() {
      const form = document.getElementById('create_customer')

      if (!form) {
        return
      }

      form.addEventListener('submit', () => {
        sessionStorage.setItem('accountRegister', 'true')
      })
    },
  },
}
</script>

<style lang="scss">
@import '~async/utils/checkbox-input/checkbox-input';
@import './customers-register';
</style>
